<div class="relative max-w-full flex gap-1.5 mt-3">
  <!-- Previous control -->
  <div class="h-full w-fit" *ngIf="images.length >= 4 && prevImage !== index">
    <div
      class="grid place-items-center border border-black rounded-sm px-0.5 md:px-1 hover:bg-black hover:text-white cursor-pointer h-[80px] xl:h-[90px]"
      (click)="prev()"
      (keydown.enter)="prev()"
      tabindex="0"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          stroke="currentColor"
          stroke-dasharray="12"
          stroke-dashoffset="12"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M8 12l7 -7M8 12l7 7"
        >
          <animate
            fill="freeze"
            attributeName="stroke-dashoffset"
            dur="0.3s"
            values="12;0"
          />
        </path>
      </svg>
    </div>
  </div>

  <div
    #thumbs
    class="flex gap-2 overflow-x-auto no_scrollbar relative"
    (touchmove)="$event.stopPropagation()"
    (wheel)="$event.stopPropagation()"
  >
    <div
      *ngFor="let image of images; let idx = index"
      class="relative rounded-lg w-[130px] xl:w-[180px] h-[80px] xl:h-[90px] flex-shrink-0 cursor-pointer transition-all duration-300 image-thumbnail bg-gray-600 overflow-hidden image-thumbnail"
      [ngClass]="{
          'border-[2.5px] !border-OUT-Blue': index === idx,
        }"
    >
      <div class="">
        <!-- Only show video icon if the image is Vimeo -->
        <span
          class="absolute bottom-2 right-2 bg-black p-1 rounded"
          *ngIf="isVimeo(image)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="size-5 text-white"
            viewBox="0 0 24 24"
          >
            <g fill="currentColor">
              <path
                d="M20.117 7.625a1 1 0 0 0-.564.1L15 10v4l4.553 2.275A1 1 0 0 0 21 15.383V8.617a1 1 0 0 0-.883-.992"
              />
              <path
                d="M5 5C3.355 5 2 6.355 2 8v8c0 1.645 1.355 3 3 3h8c1.645 0 3-1.355 3-3V8c0-1.645-1.355-3-3-3z"
              />
            </g>
          </svg>
        </span>
        <img
          [src]="image.thumbnail || image.src || image || ''"
          alt=""
          tabindex="0"
          (click)="goto(idx)"
          (keydown.enter)="goto(idx)"
        />
      </div>
    </div>
  </div>

  <!-- Next control -->
  <div class="h-full" *ngIf="images.length >= 4 && nextImage !== index">
    <div
      class="grid place-items-center border border-black rounded-sm px-0.5 md:px-1 hover:bg-black hover:text-white cursor-pointer h-[80px] xl:h-[90px]"
      (click)="next()"
      (keydown.enter)="next()"
      tabindex="0"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          stroke="currentColor"
          stroke-dasharray="12"
          stroke-dashoffset="12"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M16 12l-7 -7M16 12l-7 7"
        >
          <animate
            fill="freeze"
            attributeName="stroke-dashoffset"
            dur="0.3s"
            values="12;0"
          />
        </path>
      </svg>
    </div>
  </div>
</div>
